import PropTypes from 'prop-types';
import { Container, IconButton, Stack, Typography } from '@mui/material';
import Iconify from '@/components/iconify';
import { getBusinessRequirementSteps } from '@/consts/businessRequirements';
import BusinessRequirementStep from './BusinessRequirementStep';

export default function BusinessRequirementsScreen({ situation, onAction, onClose }) {
  const steps = getBusinessRequirementSteps(situation);

  return (
    <Container maxWidth="sm" sx={{ py: { xs: 3, md: 5 } }}>
      <Stack spacing={3}>
        <Stack direction="row" justifyContent="flex-end">
          <IconButton onClick={onClose} aria-label="Fechar">
            <Iconify icon="eva:close-fill" width={20} />
          </IconButton>
        </Stack>

        <Stack spacing={1}>
          <Typography variant="h4">Antes de criar um novo negócio</Typography>

          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            Novos negócios ficam disponíveis para contas que já vendem pela Cakto e estão com o
            cadastro validado.
          </Typography>
        </Stack>

        <Stack spacing={2}>
          {steps.map((step) => (
            <BusinessRequirementStep key={step.number} step={step} onAction={onAction} />
          ))}
        </Stack>
      </Stack>
    </Container>
  );
}

BusinessRequirementsScreen.propTypes = {
  situation: PropTypes.string,
  onAction: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
